module.exports = __webpack_public_path__ + "img/流程-2.8cd3054e.jpg";